export interface Property {
  id: number;
  image: string;
  tag: string;
  location: string;
  name: string;
  price: string;
  beds: string;
  baths: string;
  area: string;
}

export const propertyListings: Property[] = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1600607687644-c7171b42498f?auto=format&fit=crop&w=1200&q=80",
    tag: "Ready to Move",
    location: "Kağıthane, Istanbul",
    name: "Sinpaş Queen — 1+1",
    price: "From $195,000 USD",
    beds: "1 Bed",
    baths: "1 Bath",
    area: "68 m²"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1600047509358-9dc75507daeb?auto=format&fit=crop&w=1200&q=80",
    tag: "Off-Plan",
    location: "Başiskele, Kocaeli",
    name: "Akkurt Residence — 2+1",
    price: "From $145,000 USD",
    beds: "2 Bed",
    baths: "1 Bath",
    area: "95 m²"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1448630360428-65456885c650?auto=format&fit=crop&w=1200&q=80",
    tag: "New Launch",
    location: "Yuvacık, Kocaeli",
    name: "Pekdemir Heights — 3+1",
    price: "From $220,000 USD",
    beds: "3 Bed",
    baths: "2 Bath",
    area: "140 m²"
  }
];